exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".post-title {\n  font-size: 14px;\n  font-weight: bold;\n}", ""]);

// exports
